import React from 'react';
import { t } from '@sm/intl';
import { Link } from 'react-router-dom';
import { Box } from '@wds/box';
import { IconArrowLeft } from '@wds/icons';

import COPY from '~app/pages/Pricing/copy';

import useStyles from './useStyles';

export default function BackToSummary({ url }: { url: string }): JSX.Element {
  const { Back } = useStyles();
  const text = t(COPY.BACK_TO_SUMMARY);

  return (
    <Box className={Back}>
      <Link to={url}>
        <IconArrowLeft title={text} size="sm" /> {text}
      </Link>
    </Box>
  );
}
